import { FormModel } from '../../../../../components/Form';
import { Validators } from '../../../../../utils/validators';

export const EditOrgMasterDataFormModel = (strings: any, dataType: string, inputType: string): FormModel[] => {
  return [
    {
      label: strings.organization_master_data_column_key,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'masterDataKey',
      validators: [],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
      disabled: true,
    },
    {
      label: dataType.toLowerCase().includes('List'.toLowerCase())
        ? `${strings.organization_master_data_column_input}`
        : `${strings.organization_master_data_column_value}`,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: inputType,
      typeValue: dataType === 'Number' ? 'number' : 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'masterDataValue',
      validators:
        dataType !== 'Email-List'
          ? [{ check: Validators.validateMandatoryField }]
          : [{ check: Validators.validateMandatoryField }, { check: Validators.validateEmailList }],
      responsive: { xs: 12 },
      required: true,
      multiline: true,
      minRows: 1,
      maxRows: 50,
    },
  ];
};
